// Minimal slice of ptc-core CRM's viewDefinition.ts — only the pieces the verbatim
// `useListSearchParams` copy depends on (spec 2026-07-22 unified list-filters program).

export interface ViewSort {
  col: string;
  dir: 'asc' | 'desc';
}

/** Default list page size; omitted from the URL when active (spec §"URL / query grammar"). */
export const DEFAULT_PAGE_SIZE = 50;

/** Date-bucket granularities for GROUP BY (fleet filter contract v2 §13.3, M4). */
export type GroupGranularity = 'year' | 'quarter' | 'month' | 'week' | 'day';

export const GROUP_GRANULARITIES: readonly GroupGranularity[] = ['year', 'quarter', 'month', 'week', 'day'];

/**
 * The grouped column (v2 §11, RULE V1): `group=<col>` + `groupBy=<granularity>`. One column, one
 * granularity — multi-level grouping is out of scope (§13.5). `granularity` is null for a non-date
 * column; on a date column an absent `groupBy` means month.
 */
export interface ViewGroup {
  col: string;
  granularity: GroupGranularity | null;
}
